<template>
    <div>
        <button
            type="button"
            class="flex items-center rounded-full bg-gray-100 border-xs border-white"
            :disabled="! enabled"
            @click="like"
        >
            <span
                v-if="enabled"
                class="py-xs px-sm rounded-l-full"
                :class="comment.like_count ? 'bg-gray-200' : ''"
            >
                <span :class="comment.is_liked_by_user ? 'font-semibold text-green-500' : 'font-medium text-gray-800'">
                    Gilla
                </span>
            </span>
            <span
                v-if="comment.like_count"
                class="py-xs px-sm"
                :title="comment.like_users_concatenated_names"
            >
                <font-awesome-icon :icon="['far', 'thumbs-up']" />
                <span class="">{{ comment.like_count }}</span>
            </span>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            initialComment: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                comment: this.initialComment,
            };
        },

        computed: {
            enabled() {
                return window.App.userId !== this.comment.author_user_id;
            },
        },

        methods: {
            async like() {
                if (! window.App.userId) {
                    this.$modal.show('create-account');
                    return;
                }

                try {
                   const response = await axios.post(
                        route('front.api.products.comments.like', [this.comment.product_id, this.comment.id]),
                   );
                   this.comment = response.data;
                } catch (error) {
                    if (error.response && error.response.status === 401) {
                        this.$modal.show('login');
                        return;
                    }

                    throw error;
                }
            },
        },
    };
</script>
